import {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpFeatureFlagLeadTopicForm} from "../app/read_rp_environment_variables";

export enum OngoingABTests {
    PLANER_VERIFICATION = "PLANER_VERIFICATION",
    MULTI_LEAD_SUMMARY = "MULTI_LEAD_SUMMARY",
    OPINIONS_USER_INTEREST = "OPINIONS_USER_INTEREST",
    LEAD_TOPIC_FORM = "LEAD_TOPIC_FORM"
}

/**
 * Hidden prices - in the future, tests will probably be restored (in some form), below is the MR that removed that test.
 * @see https://git.rynekpierwotny.com/propertygroup/mono/-/merge_requests/3606
 */

export enum LeadTopicFormVariant {
    HIDDEN = 0,
    VISIBLE = 1
}

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "Yy99k333zk71O3b0bG1y",
        expires: new Date(2025, 9, 1),
        name: OngoingABTests.MULTI_LEAD_SUMMARY,
        path: [],
        matchOnAllPaths: true,
        variants: 2,
        withSSR: false
    },
    {
        id: "zxIMyz207kz7og0ulmkq",
        expires: new Date(2025, 3, 30),
        name: OngoingABTests.OPINIONS_USER_INTEREST,
        path: [rpAppPath.offer.detail.base, rpAppPath.property.detail.base],
        variants: 1,
        withSSR: false
    },
    ...(rpFeatureFlagLeadTopicForm
        ? [
              {
                  id: "n91o03kzz7kg11ppttoi",
                  expires: new Date(2026, 5, 31),
                  name: OngoingABTests.LEAD_TOPIC_FORM,
                  path: [rpAppPath.property.detail.base],
                  matchOnAllPaths: true,
                  variants: 1,
                  withSSR: true
              }
          ]
        : [])
];
import {IABTestConfiguration} from "@pg-mono/ab-testing";
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpFeatureFlagLeadTopicForm} from "../app/read_rp_environment_variables";

export enum OngoingABTests {
    PLANER_VERIFICATION = "PLANER_VERIFICATION",
    MULTI_LEAD_SUMMARY = "MULTI_LEAD_SUMMARY",
    OPINIONS_USER_INTEREST = "OPINIONS_USER_INTEREST",
    LEAD_TOPIC_FORM = "LEAD_TOPIC_FORM"
}

/**
 * Hidden prices - in the future, tests will probably be restored (in some form), below is the MR that removed that test.
 * @see https://git.rynekpierwotny.com/propertygroup/mono/-/merge_requests/3606
 */

export enum LeadTopicFormVariant {
    HIDDEN = 0,
    VISIBLE = 1
}

/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "Yy99k333zk71O3b0bG1y",
        expires: new Date(2025, 9, 1),
        name: OngoingABTests.MULTI_LEAD_SUMMARY,
        path: [],
        matchOnAllPaths: true,
        variants: 2,
        withSSR: false
    },
    {
        id: "zxIMyz207kz7og0ulmkq",
        expires: new Date(2025, 3, 30),
        name: OngoingABTests.OPINIONS_USER_INTEREST,
        path: [rpAppPath.offer.detail.base, rpAppPath.property.detail.base],
        variants: 1,
        withSSR: false
    },
    ...(rpFeatureFlagLeadTopicForm
        ? [
              {
                  id: "n91o03kzz7kg11ppttoi",
                  expires: new Date(2026, 5, 31),
                  name: OngoingABTests.LEAD_TOPIC_FORM,
                  path: [rpAppPath.property.detail.base],
                  matchOnAllPaths: true,
                  variants: 1,
                  withSSR: true
              }
          ]
        : [])
];
